import { render, staticRenderFns } from "./EduButtonDelete.vue?vue&type=template&id=5ef296ca&scoped=true"
import script from "./EduButtonDelete.vue?vue&type=script&lang=js"
export * from "./EduButtonDelete.vue?vue&type=script&lang=js"
import style0 from "./EduButtonDelete.vue?vue&type=style&index=0&id=5ef296ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef296ca",
  null
  
)

export default component.exports